<template>
	<div>
		<div class="drag">
            <div class="drag_bg"></div>
            <div class="drag_text">{{confirmWords}}</div>
            <div @mousedown="mousedownFn($event)" class="handler handler_bg"></div>
        </div>
	</div>
</template>
<style scoped>
    .drag{ 
        position: relative; 
        background-color: #e8e8e8; 
        width: 200px; 
        height: 30px; 
        line-height: 30px; 
        text-align: center; 
        font-family: Helvetica;
        color: #272727;
    }
    .handler{ 
        position: absolute; 
        top: 0px; 
        left: 0px; 
        width: 30px; 
        height: 30px; 
        border: 1px solid #ccc; 
        cursor: move; 
    }
    .drag_bg{ 
        background-color: #7ac23c; 
        height: 30px; 
        width: 0px; 
    } 
    .drag_text{ 
        position: absolute; 
        top: 0px; 
        width: 200px; 
        -moz-user-select: none; 
        -webkit-user-select: none; 
        user-select: none; 
        -o-user-select:none; 
        -ms-user-select:none; 
    }
    .handler_bg{ 
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center; 
    } 
    .handler_ok_bg{ 
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center; 
    }
</style>
<script>
    export default {
        name: '',
        components: {},
        props: {},
        data(){
            return{
                beginClientX:0, /*距离屏幕左端距离*/
                mouseMoveStata:false, /*触发拖动状态 判断*/
                maxwidth:170, /*拖动最大宽度，依据滑块宽度算出来的*/
                confirmWords:'Drag slider validation', /*滑块文字*/
            }
        },
        computed: {

        },
        created(){
            
        },
        mounted:function(){
            this.mouse();
        },
        watch:{
            
        },
        methods: {
            //按下滑块函数 
            mousedownFn(e){
                this.mouseMoveStata = true;
                this.beginClientX = e.clientX;
            },
            //鼠标事件
            mouse(){
                //拖动，这里需要用箭头函数，不然this的指向不会是vue对象
                $('body').on('mousemove',(e) => {
                    if(this.mouseMoveStata){
                        var width = e.clientX - this.beginClientX;
                        if(width>0 && width<=this.maxwidth){
                            $(".handler").css({'left':width});
                            $(".drag_bg").css({'width': width});
                        }else if(width>this.maxwidth){
                            this.successFunction();
                        }
                    }
                });
                //鼠标放开
                $('body').on('mouseup',(e) => {
                    this.mouseMoveStata = false;
                    var width = e.clientX - this.beginClientX;
                    if(width<this.maxwidth){
                        $(".handler").css({'left':0});
                        $(".drag_bg").css({'width': 0});
                    }
                })
            },
            //验证成功函数
            successFunction(){
                $(".handler").removeClass('handler_bg').addClass('handler_ok_bg');
                this.confirmWords = 'Success';
                $(".drag").css({'color': '#fff'});
                $(".handler").css({'left':this.maxwidth});
                $(".drag_bg").css({'width': this.maxwidth});
                $('body').unbind('mousemove');
                $('body').unbind('mouseup');
                //验证成功判断
                this.$store.state.verificationSuccess = true;
            },
            //手动恢复事件
            history(){
                $(".handler").removeClass('handler_ok_bg').addClass('handler_bg');
                this.mouseMoveStata = true;
                this.beginClientX = 0;
                $(".handler").css({'left':0});
                $(".drag_bg").css({'width': 0});
                this.confirmWords = 'Drag slider validation';
                $(".drag").css({'color': '#272727'});
                $(".drag").css({'background-color': '#e8e8e8'});
                this.mouse();
            }
        },

    }
</script>


// WEBPACK FOOTER //
// VerificationSlider.vue?e045aa72